import PageHero from '../modules/PageHero';
import { $ } from '@starberry/components';

export default {
  $: 'Dashboard',
  title: 'Inbox',
  content: [
    {
      $: 'Flex',
      children: [
        {
          $: 'SimpleTabs',
          props: {
            flex: 1,
            tabs: [
              {
                title: 'Pending Actions',
                id: 'pending-actions',
                content: {
                  $: 'PendingActions',
                  hideTitle: true,
                  props: {
                    pt: '30px',
                    px: $('theme.space.12'),
                  },
                },
              },
              {
                title: 'Recent Activity',
                id: 'recent-activity',
                content: {
                  $: 'ActivityHistory',
                  hideTitle: true,
                  props: {
                    pt: '30px',
                    px: $('theme.space.12'),
                  },
                },
              },
            ],
          },
        },
      ],
    },
  ],
};
